<template>
    <div class="login-client">
        <el-dialog
                :before-close="destroyOnClose"
                :close-on-click-modal="false"
                :show-close="false"
                :visible.sync="isOpenLoginDialog"
                width="30%">
            <el-form
                    :label-position="labelPosition"
                    :model="loginForm"
                    :rules="rules"
                    @submit.native.prevent="submitForm('loginForm')"
                    class="login-form"
                    label-width="150px"
                    ref="loginForm"
            >
                <div class="messages" v-if="!flashMessage" v-html="this.messages"></div>
                <el-alert
                    v-if="flashMessage"
                    class="login-flash-message"
                    :title="flashMessage"
                    type="warning"
                    show-icon
                    :closable="false"
                />
                <div class="login-sso-notice">
                    <p class="login-sso-notice__title">
                        <i class="el-icon-info login-sso-notice__icon" aria-hidden="true"></i>
                        AIユイゴン&nbsp;Well-Bをご利用の方へ
                    </p>
                    <p class="login-sso-notice__text">
                        AIユイゴン&nbsp;Well-Bをお使いの方は、AIユイゴン&nbsp;Well-Bのログイン情報をご利用頂けます。
                    </p>
                </div>
                <el-form-item label="ID" prop="loginId">
                    <el-input :autofocus="isOpenLoginDialog" placeholder="ID" ref="loginId"
                              v-model="loginForm.loginId"></el-input>
                    <el-checkbox v-model="cbSaveLoginId">IDを保存する</el-checkbox>
                </el-form-item>
                <el-form-item label="パスワード" prop="password">
                    <el-input placeholder="パスワード" ref="password" type="password"
                              v-model="loginForm.password"></el-input>
                </el-form-item>
                <el-form-item>
                    <a @click="closeLoginModal('loginForm') + (dialogForgotLoginIdVisible = true)"
                       class="forgot-password">※ログインIDを忘れた方はこちら</a><br>
                    <a @click="closeLoginModal('loginForm') + (dialogForgotPasswordVisible = true)"
                       class="forgot-password gtm_top_pwreminder_yop">※パスワードを忘れた方はこちら</a>
                </el-form-item>
                <el-form-item class="sm-btn-center">
                    <el-button @click="closeForm('loginForm')">キャンセル</el-button>
                    <el-button :disabled="loading" native-type="submit">ログインする</el-button>
                </el-form-item>
            </el-form>
            <ul>
              <li class="caution-text">※Apple製品（iOS/Mac）をお使いの方は、Appleの仕様によりブラウザへのIDの保存期間が1週間に設定されます。</li>
            </ul>
        </el-dialog>
        <ForgotPassword :dialogForgotPasswordVisible="dialogForgotPasswordVisible"
                        @hideForgotPasswordModal="hideForgotPasswordModal"/>
        <ForgotLoginId :dialogForgotLoginIdVisible="dialogForgotLoginIdVisible"
                       @hideForgotLoginIdModal="hideForgotLoginIdModal"/>
    </div>
</template>

<script>
  import Vue from 'vue'
  import JwtService from '@/common/jwt.service'
  import ForgotPassword from './ForgotPassword.vue'
  import ForgotLoginId from './ForgotLoginId.vue'
  import { mapGetters } from 'vuex'
  import { LOGIN_CLIENT, SET_OPEN_LOGIN_DIALOG } from '@/store/actions.type'
  import { SET_AUTH_CLIENT } from '@/store/mutations.type'
  import { routeNameForSessionFlag as jailRouteNameForSessionFlag } from '@/common/sessionFlagRouting'
  import saveLoginIdMixin from '../../../../mixins/saveLoginIdMixin'

  export default {
    name: 'login-client',
    mixins: [saveLoginIdMixin],
    data () {
      return {
        labelPosition: 'left',
        loginForm: {
          loginId: '',
          password: ''
        },
        showModal: false,
        loading: false,
        messages: 'ログインするIDとパスワードを入力してください',
        flashMessage: '',
        rules: {
          loginId: [
            { required: true, message: 'IDを入力してください', trigger: 'blur' }
          ],
          password: [
            { required: true, message: 'パスワードを入力してください', trigger: 'blur' }
          ]
        },
        dialogForgotPasswordVisible: false,
        dialogForgotLoginIdVisible: false,
        forgotPasswordForm: {
          email: ''
        }
      }
    },
    components: {
      ForgotPassword,
      ForgotLoginId
    },
    computed: {
      ...mapGetters(['isOpenLoginDialog', 'isPasswordReminded', 'loginDialogContext'])
    },
    watch: {
      isOpenLoginDialog () {
        if (this.isOpenLoginDialog) {
          let self = this
          let loginIdSaved = JwtService.getCookie('savedLoginId')
          if (loginIdSaved) {
            self.loginForm.loginId = loginIdSaved.loginId
            self.cbSaveLoginId = loginIdSaved.cbSaveLoginId
          }
          this.applyLoginDialogContext()
          Vue.nextTick()
            .then(function () {
              // el-dialog only mounts its body content on its own first-ever open - if this
              // dialog has never opened in this session yet (e.g. a session-violation redirect
              // before the user manually clicks "ログイン"), these refs may still be undefined
              // even after nextTick. Guarded rather than assumed present.
              if (self.loginForm.loginId) {
                if (self.$refs.password) {
                  self.$refs.password.focus()
                }
              } else if (self.$refs.loginId) {
                self.$refs.loginId.focus()
              }
            })
        }
      }
    },
    methods: {
      applyLoginDialogContext () {
        const context = this.loginDialogContext
        if (context && context.flashMessage) {
          this.flashMessage = context.flashMessage
        } else {
          this.flashMessage = ''
        }
        if (context && context.loginId) {
          this.loginForm.loginId = context.loginId
        }
      },
      async submitForm (formName) {
        await this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true
            let user = JwtService.getUser()
            if (JwtService.getToken() && user !== null) {
              this.loading = false
              this.closeForm('loginForm')
              this.$router.push({ name: this.routeNameForSessionFlag() || 'portalMember' })
              this.$store.commit(SET_AUTH_CLIENT, user)
              this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, false)
            } else {
              let loginData = {
                loginId: this.loginForm.loginId,
                password: this.loginForm.password
              }
              this.$store.dispatch(LOGIN_CLIENT, loginData)
                .then((response) => {
                  this.loading = false
                  if (response.status === 200) {
                    this.doSaveLoginId(this.loginForm.loginId)
                    this.closeForm('loginForm')
                    // A quarantine/terms-jail session must land directly on its own jail's
                    // screen before any of the ordinary routeName-based destinations below run -
                    // none of those are on the jail's whitelist, so letting the router guard
                    // catch the violation would destroy the just-issued token instead.
                    const jailRouteName = this.routeNameForSessionFlag()
                    if (jailRouteName) {
                      this.$router.push({ name: jailRouteName })
                      return
                    }
                    let routeName = localStorage.getItem('routeName')
                    if (routeName === 'memberInfo') {
                      this.$router.push('member/info', () => {
                      })
                      localStorage.removeItem('routeName')
                      this.passwordReminded()
                    } else if (routeName === 'anken') {
                      this.$router.push({ name: 'anken' })
                      localStorage.removeItem('routeName')
                      this.passwordReminded()
                    } else if (this.$route.name === 'seminar') {
                      let seminarId = parseInt(localStorage.getItem('redirectSeminar'))
                      if (seminarId > 0) {
                        this.$router.push('seminar/' + seminarId + '/join', () => {
                        })
                        this.passwordReminded()
                      } else {
                        this.$router.go()
                        this.passwordReminded()
                      }
                    } else if (this.$route.name === 'CustomerSurvey') {
                      // this.$router.push({ name: 'home' })
                    } else if (this.$route.name === 'demoChronology') {
                      this.$router.push({ name: 'chronology' })
                      this.passwordReminded()
                    } else if (this.$route.name === 'globalInvoiceFlag') {
                      // 相続税チェックリストのポップアップでログインした場合は、TOP画面に遷移しない
                      this.passwordReminded()
                    } else {
                      // this.$bus.$emit('refreshData', this.$route.name)
                      this.$router.push({ name: 'portalMember' })
                      this.passwordReminded()
                    }
                  } else {
                    this.messages = 'エラー'
                  }
                })
                // eslint-disable-next-line handle-callback-err
                .catch(err => {
                  this.loading = false
                  this.loginForm.password = ''
                  this.messages = `ID又はパスワードが違います <br>
                                  再度入力してやり直してください`
                  var status = err.response.status
                  if (status === 418) {
                    this.messages = '５回パスワードを間違えたため、パスワード再設定を行ってください'
                  }
                })
            }
          } else {
            return false
          }
        })
      },
      // Returns the jail's own destination route name for a quarantine/terms-jail session
      // flag, or null for ACTIVE - the caller falls back to its own ordinary destination.
      routeNameForSessionFlag () {
        return jailRouteNameForSessionFlag(JwtService.getSessionFlag())
      },
      // Turned off at the client's own request - password_update_at can go stale (e.g. a
      // password changed via Cognito from outside this system), making the warning unreliable.
      // Left as a no-op rather than removing the SET_PASSWORD_REMIND plumbing, so this can be
      // turned back on by restoring this method's body alone.
      passwordReminded () {},
      closeForm (formName) {
        this.destroyOnClose()
      },
      destroyOnClose () {
        this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, false)
        this.messages = 'ログインするIDとパスワードを入力してください'
        this.flashMessage = ''
        this.$refs['loginForm'].resetFields()
      },
      hideForgotPasswordModal (val) {
        this.dialogForgotPasswordVisible = val
      },
      hideForgotLoginIdModal (val) {
        this.dialogForgotLoginIdVisible = val
      },
      closeLoginModal (formName) {
        this.$refs[formName].resetFields()
        this.$store.dispatch(SET_OPEN_LOGIN_DIALOG, false)
      }
    }
  }
</script>

<style scoped>
    @import './login.css';
</style>
